export default {"src":"/_next/static/media/5.23805668.svg","height":24,"width":20,"blurWidth":0,"blurHeight":0};